<template>
  <div class="option-list__item-wrapper type--sub-goal">
    <button
      class="option-list__item"
      v-on:click="onClick"
    >
      <div class="option-list__item__header">
        <h3 class="option-list__item__title">{{ option.Header}}</h3>
        <img :src="option.IconUrl" v-if="option.IconUrl" class="option-list__item__icon" alt="">
      </div>
      <div class="option-list__item__content">
        <div class="rich-text" v-html="option.Description"></div>
      </div>
      <div class="option-list__item__button button is--yellow is--solid has--icon">
        {{option.ButtonText}}
      </div>
    </button>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState, mapGetters, mapMutations } from 'vuex';
//
@Component({
  data() {
    return {

    }
  },
  props: {
  },
  computed: {
    ...mapState({
      currentStepIndex: state => state.buyGuide.currentStepIndex,
      steps: state => state.buyGuide.steps,
    })
  },
  components: {
  },
  methods: {
    ...mapMutations([
      'buyGuide/setSelectedOption',
      'buyGuide/setCurrentStepIndex',
      'buyGuide/toggleShowResult'
    ])
  }
})
export default class OptionSubGoal extends Vue {
  @Prop() option;
  @Prop() optionIndex;
  @Prop() stepIndex;

  created() {
  }

  onClick() {
    if (this.option.ButtonAction === 'continue') {
      this.continueMatch();
    }
    else if (this.option.ButtonAction === 'show') {
      this.showMatch();
    }
  }

  showMatch() {
    console.log('showMatch');
    this.$store.commit(
      'buyGuide/toggleShowResult', {
        showResult: true
    })
  }

  continueMatch() {
    console.log('continueMatch');
    this.$store.commit(
      'buyGuide/setCurrentStepIndex', {
        currentStepIndex: this.currentStepIndex + 1
      }
    )
  }



}
</script>

<style>

</style>

